import { post } from '../http';

const sendTelemetry = async (data) => {
  return post(`/api/t`, data);
};

const TelemetryController = { sendTelemetry };

export default TelemetryController;
